import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Reason from './Reason'
import store from './store'
export default class extends Component {
  constructor(props) {
    super(props)

    const {
      location: {
        query: { type, kind }
      },
      params: { id }
    } = props
    store.setId(id, type, kind)
  }

  render() {
    return (
      <HeaderView title="申诉">
        <Reason />
      </HeaderView>
    )
  }
}
